import { onCustomEvent as d } from "@scalar/workspace-store/events";
const O = (b, m, S, a) => {
  const { servers: n, serverMutators: u, requestMutators: h, collectionMutators: v, securitySchemeMutators: o } = m, { activeCollection: i, activeServer: f } = S;
  d(a, "scalar-replace-servers", ({ detail: { servers: r, options: e } }) => {
    if ((e == null ? void 0 : e.disableOldStoreUpdate) === !0)
      return;
    const t = i.value;
    if (!t)
      return console.warn("No active collection found");
    t.servers.forEach((l) => {
      u.delete(l, t.uid);
    }), r.forEach((l) => {
      const s = Object.values(n).find((U) => U.url === l.url);
      s && u.add(s, t.uid);
    });
    const c = Object.values(n).find((l) => {
      var s;
      return l.url === ((s = r.at(-1)) == null ? void 0 : s.url);
    });
    v.edit(t.uid, "selectedServerUid", c == null ? void 0 : c.uid);
  }), d(a, "scalar-update-selected-server", ({ detail: { value: r, options: e } }) => {
    if ((e == null ? void 0 : e.disableOldStoreUpdate) === !0)
      return;
    const t = i.value;
    if (!t)
      return;
    const c = Object.values(n).find((l) => l.url === r);
    c && v.edit(t.uid, "selectedServerUid", c.uid);
  }), d(a, "store-update-selected-server-properties", ({ detail: { key: r, value: e, options: t } }) => {
    if (t != null && t.disableOldStoreUpdate)
      return;
    const c = f.value;
    c && u.edit(c.uid, r, e);
  }), d(a, "scalar-update-selected-server-variables", ({ detail: { key: r, value: e, options: t } }) => {
    var s;
    if ((t == null ? void 0 : t.disableOldStoreUpdate) === !0)
      return;
    const c = f.value;
    if (!c || c.url !== ((s = b.workspace.activeDocument) == null ? void 0 : s["x-scalar-active-server"]))
      return;
    const l = c.variables || {};
    l[r] = { ...l[r], default: e }, u.edit(c.uid, "variables", l);
  }), d(a, "scalar-select-security-schemes", ({ detail: { uids: r } }) => {
    const e = i.value;
    if (!e)
      return console.warn("No active collection found");
    v.edit(e.uid, "selectedSecuritySchemeUids", r);
  }), d(a, "scalar-select-operation-security-schemes", ({ detail: { operationUid: r, uids: e } }) => {
    h.edit(r, "selectedSecuritySchemeUids", e);
  }), d(a, "scalar-edit-security-scheme", ({ detail: { uid: r, path: e, value: t } }) => {
    o.edit(r, e, t);
  }), d(a, "scalar-add-auth-option", ({ detail: { payload: r } }) => {
    const e = i.value;
    if (!e)
      return console.warn("No active collection found");
    o.add(r, e.uid);
  }), d(a, "scalar-delete-security-scheme", ({ detail: { uid: r } }) => {
    if (!i.value)
      return console.warn("No active collection found");
    o.delete(r);
  });
};
export {
  O as useLegacyStoreEvents
};
